{
  "_meta": {
    "_table": {
      "label": "Service Job",
      "plural": "Service Jobs",
      "icon": "Wrench"
    },
    "Name": {
      "type": "Text",
      "label": "Job title",
      "required": true
    },
    "service_c": {
      "type": "Picklist",
      "label": "Service category",
      "values": "Air conditioning,Plumbing,Electrical,Appliance repair,Water purifier,Other",
      "required": true
    },
    "customerName_c": {
      "type": "Text",
      "label": "Customer name",
      "required": true
    },
    "phone_c": {
      "type": "Text",
      "label": "Customer phone"
    },
    "status_c": {
      "type": "Picklist",
      "label": "Status",
      "values": "Pending,Assigned,Accepted,Rejected,In progress,Completed,Cancelled",
      "required": true
    },
    "scheduledAt_c": {
      "type": "DateTime",
      "label": "Scheduled visit",
      "required": true
    },
    "address_c": {
      "type": "Text",
      "label": "Service address",
      "required": true
    },
    "notes_c": {
      "type": "MultilineText",
      "label": "Job notes"
    },
    "verificationStatus_c": {
      "type": "Picklist",
      "label": "Customer verification status",
      "values": "Pending,Verified"
    },
    "customerRating_c": {
      "type": "Text",
      "label": "Customer rating"
    },
    "customerReview_c": {
      "type": "MultilineText",
      "label": "Customer review"
    },
    "workerResponse_c": {
      "type": "MultilineText",
      "label": "Worker follow-up note"
    },
    "rejectionReason_c": {
      "type": "MultilineText",
      "label": "Order rejection reason"
    }
  },
  "records": [
    {
      "Id": "00000001-2000-4000-8000-000000000001",
      "Name": "AC service — Huvinahadagali",
      "service_c": "Air conditioning",
      "customerName_c": "Ramesh K.",
      "status_c": "Assigned",
      "scheduledAt_c": "2026-10-14T10:30:00Z",
      "address_c": "Near Shastri Circle",
      "phone_c": "+91 90000 10000",
      "notes_c": "",
      "CreatedOn": "2026-10-05T08:30:00Z",
      "ModifiedOn": "2026-10-05T08:30:00Z",
      "Owner": {
        "Id": "00000000-0000-4000-8000-000000000001",
        "Name": "AryanFix Admin"
      }
    },
    {
      "Id": "00000002-2000-4000-8000-000000000002",
      "Name": "Kitchen tap repair",
      "service_c": "Plumbing",
      "customerName_c": "Sanjay P.",
      "status_c": "Pending",
      "scheduledAt_c": "2026-10-14T11:15:00Z",
      "address_c": "Ward 4, Huvinahadagali",
      "phone_c": "+91 90000 10001",
      "notes_c": "Confirm arrival with customer.",
      "CreatedOn": "2026-10-06T08:30:00Z",
      "ModifiedOn": "2026-10-06T08:30:00Z",
      "Owner": {
        "Id": "00000000-0000-4000-8000-000000000001",
        "Name": "AryanFix Admin"
      }
    },
    {
      "Id": "00000003-2000-4000-8000-000000000003",
      "Name": "Switchboard replacement",
      "service_c": "Electrical",
      "customerName_c": "Meena R.",
      "status_c": "In progress",
      "scheduledAt_c": "2026-10-14T12:00:00Z",
      "address_c": "Main Road",
      "phone_c": "+91 90000 10002",
      "notes_c": "Bring required tools and record parts used.",
      "CreatedOn": "2026-10-07T08:30:00Z",
      "ModifiedOn": "2026-10-07T08:30:00Z",
      "Owner": {
        "Id": "00000000-0000-4000-8000-000000000001",
        "Name": "AryanFix Admin"
      }
    },
    {
      "Id": "00000004-2000-4000-8000-000000000004",
      "Name": "Washing machine diagnosis",
      "service_c": "Appliance repair",
      "customerName_c": "Kiran S.",
      "status_c": "Completed",
      "scheduledAt_c": "2026-10-13T16:00:00Z",
      "address_c": "Vijayanagara District",
      "phone_c": "+91 90000 10003",
      "notes_c": "",
      "verificationStatus_c": "Verified",
      "customerRating_c": "5",
      "customerReview_c": "Clear explanation and careful work. Arrived on time.",
      "workerResponse_c": "Thank you for the feedback.",
      "CreatedOn": "2026-10-08T08:30:00Z",
      "ModifiedOn": "2026-10-08T08:30:00Z",
      "Owner": {
        "Id": "00000000-0000-4000-8000-000000000001",
        "Name": "AryanFix Admin"
      }
    },
    {
      "Id": "00000005-2000-4000-8000-000000000005",
      "Name": "RO filter replacement",
      "service_c": "Water purifier",
      "customerName_c": "Naveen B.",
      "status_c": "Assigned",
      "scheduledAt_c": "2026-10-14T14:00:00Z",
      "address_c": "Bus stand road",
      "phone_c": "+91 90000 10004",
      "notes_c": "",
      "CreatedOn": "2026-10-09T08:30:00Z",
      "ModifiedOn": "2026-10-09T08:30:00Z",
      "Owner": {
        "Id": "00000000-0000-4000-8000-000000000001",
        "Name": "AryanFix Admin"
      }
    },
    {
      "Id": "00000006-2000-4000-8000-000000000006",
      "Name": "Ceiling fan installation",
      "service_c": "Electrical",
      "customerName_c": "Ravi T.",
      "status_c": "Pending",
      "scheduledAt_c": "2026-10-15T09:00:00Z",
      "address_c": "Near market",
      "phone_c": "+91 90000 10005",
      "notes_c": "",
      "CreatedOn": "2026-10-10T08:30:00Z",
      "ModifiedOn": "2026-10-10T08:30:00Z",
      "Owner": {
        "Id": "00000000-0000-4000-8000-000000000001",
        "Name": "AryanFix Admin"
      }
    },
    {
      "Id": "00000007-2000-4000-8000-000000000007",
      "Name": "Bathroom leakage",
      "service_c": "Plumbing",
      "customerName_c": "Sanjay P.",
      "status_c": "In progress",
      "scheduledAt_c": "2026-10-14T09:00:00Z",
      "address_c": "Ward 2",
      "phone_c": "+91 90000 10006",
      "notes_c": "",
      "CreatedOn": "2026-10-11T08:30:00Z",
      "ModifiedOn": "2026-10-11T08:30:00Z",
      "Owner": {
        "Id": "00000000-0000-4000-8000-000000000001",
        "Name": "AryanFix Admin"
      }
    },
    {
      "Id": "00000008-2000-4000-8000-000000000008",
      "Name": "AC not cooling",
      "service_c": "Air conditioning",
      "customerName_c": "Ramesh K.",
      "status_c": "Completed",
      "scheduledAt_c": "2026-10-12T15:30:00Z",
      "address_c": "Station road",
      "phone_c": "+91 90000 10007",
      "notes_c": "",
      "verificationStatus_c": "Verified",
      "customerRating_c": "4",
      "customerReview_c": "Service was good; the issue was explained clearly.",
      "CreatedOn": "2026-10-12T08:30:00Z",
      "ModifiedOn": "2026-10-12T08:30:00Z",
      "Owner": {
        "Id": "00000000-0000-4000-8000-000000000001",
        "Name": "AryanFix Admin"
      }
    },
    {
      "Id": "00000009-2000-4000-8000-000000000009",
      "Name": "Fridge cooling check",
      "service_c": "Appliance repair",
      "customerName_c": "Anita S.",
      "status_c": "Pending",
      "scheduledAt_c": "2026-10-16T10:00:00Z",
      "address_c": "Housing board",
      "phone_c": "+91 90000 10008",
      "notes_c": "",
      "CreatedOn": "2026-10-13T08:30:00Z",
      "ModifiedOn": "2026-10-13T08:30:00Z",
      "Owner": {
        "Id": "00000000-0000-4000-8000-000000000001",
        "Name": "AryanFix Admin"
      }
    },
    {
      "Id": "00000010-2000-4000-8000-000000000010",
      "Name": "RO annual service",
      "service_c": "Water purifier",
      "customerName_c": "Mahesh G.",
      "status_c": "Assigned",
      "scheduledAt_c": "2026-10-17T11:30:00Z",
      "address_c": "College road",
      "phone_c": "+91 90000 10009",
      "notes_c": "",
      "CreatedOn": "2026-10-14T08:30:00Z",
      "ModifiedOn": "2026-10-14T08:30:00Z",
      "Owner": {
        "Id": "00000000-0000-4000-8000-000000000001",
        "Name": "AryanFix Admin"
      }
    }
  ]
}